import { RadioButtonWithLabelOption } from '@tableau/widgets';
import React from 'react';

import { FormikRadioButtonGroup } from '~commonInfra/components/FormikRadioButtonGroup';
import { Messages } from '~src/codegen/Localize';
import { SettingsSection } from '~src/settings/components/common/SettingsSection';
import { componentRegistryEntry } from '~src/settings/general-settings/components/SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '~src/settings/general-settings/components/site-settings/ReactSiteSettingsForSiteAdmin';
import { settingsRadioButtonItemHeight } from '~src/settings/styles/CommonStyles';

export const DATA_ORIENTATION_ADMIN_SETTINGS_SECTION_TEST_ID = 'data-orientation-admin-settings-site-setting';
export const DATA_ORIENTATION_ADMIN_SETTINGS_ENABLED_BUTTON_TEST_ID = 'data-orientation-admin-settings-enabled';
export const DATA_ORIENTATION_ADMIN_SETTINGS_DISABLED_BUTTON_TEST_ID = 'data-orientation-admin-settings-disabled';

export type DataOrientationAdminSettingsSectionProps = SiteSettingsForSiteAdminProps<'dataOrientationEnabled'>;

/**
 * Settings section for data orientation auto launch feature
 */
export function DataOrientationAdminSettingsSection() {
  const buttonList: RadioButtonWithLabelOption<boolean>[] = [
    {
      value: true,
      label: Messages.dataOrientationAdminSettingsEnabled(),
      detail: Messages.dataOrientationAdminSettingsEnabledDescription(),
      testId: DATA_ORIENTATION_ADMIN_SETTINGS_ENABLED_BUTTON_TEST_ID
    },
    {
      value: false,
      label: Messages.dataOrientationAdminSettingsDisabled(),
      detail: Messages.dataOrientationAdminSettingsDisabledDescription(),
      testId: DATA_ORIENTATION_ADMIN_SETTINGS_DISABLED_BUTTON_TEST_ID
    }
  ];

  return (
    <SettingsSection
      title={Messages.dataOrientationAdminSettingsTitle()}
      testId={DATA_ORIENTATION_ADMIN_SETTINGS_SECTION_TEST_ID}>
      <FormikRadioButtonGroup
        aria-label={Messages.dataOrientationAdminSettingsTitle()}
        buttonList={buttonList}
        className={settingsRadioButtonItemHeight}
        name={'settings.dataOrientationEnabled'} />
    </SettingsSection>
  );
}

/* for registering the component in settings registry */
export const DataOrientationAdminSettingsSectionSpecs = componentRegistryEntry({
  name: 'DataOrientationAdminSettingsSection',
  component: DataOrientationAdminSettingsSection,
});